import { AvailableAction } from '@xing-com/crate-common-graphql-types';

export const actionsFilter: AvailableAction[] = [
  AvailableAction.AddContact,
  AvailableAction.DeleteContact,
  AvailableAction.DeclineContactRequest,
  AvailableAction.BlockUser,
  AvailableAction.ConfirmContact,
  AvailableAction.EditXingId,
  AvailableAction.Follow,
  AvailableAction.OpenInsiderCollection,
  AvailableAction.OpenSettings,
  AvailableAction.OpenLoPreview,
  AvailableAction.OpenRecruiterPreview,
  AvailableAction.OpenXtm,
  AvailableAction.Print,
  AvailableAction.ReportProfile,
  AvailableAction.SendMessage,
  AvailableAction.ShowContactDetails,
  AvailableAction.Unfollow,
];
